@if (areaSearchState.nationWide_ === true && !areaSearchState.searchState.onlyNational() && areaSearchState.searchState.nationalCount() > 0) {
    <div class='national-services'>
        <span>{{areaSearchState.searchState.nationalCount()}} מהשירותים הם כלל ארציים</span>
    </div>
}
